import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useQueryClient } from 'react-query';
import { Spin } from 'antd';
import cn from 'classnames';
import useWarrantyInfo from '../../../queries/useWarrantyInfo';
import Card, { CardChangeButton, CardHeader } from '../../Card';
import EmptyBlock from './components/EmptyBlock/EmptyBlock';
import ContractorInfo from './components/ContractorInfo/ContractorInfo';
import warrantyActions from '../../../actions/warranty.actions';
import WarrantyDocs from './components/WarrantyDocs/WarrantyDocs';
import styles from './RequestContractorCard.module.scss';

const notWarrantyId = 0;

const WarrantyInfoBlock = ({ warrantyInfo, onEmptyBlockClick }) => {
  return !warrantyInfo ? (
    <EmptyBlock onClick={onEmptyBlockClick} />
  ) : (
    <ContractorInfo warrantyInfo={warrantyInfo} />
  );
};

const RequestContractorCard = ({
  request,
  className,
  canChange = true,
  ...props
}) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const { postWarrantyRequestId, infoPosted } = useSelector(
    (state) => state.warrantyStore
  );
  const { CanChangeWarranty } = useSelector(
    (state) => state.authentication.userInfo
  );

  const { data: warrantyInfo, isFetching: isWarrantyInfoFetching } =
    useWarrantyInfo(request.id);

  const handleAddContractorBtnClick = () => {
    dispatch(warrantyActions.openWarrantyInfoModal(request.id, warrantyInfo));
  };

  useEffect(() => {
    if (postWarrantyRequestId === request.id && infoPosted) {
      queryClient.invalidateQueries(['contractor', request.id]);

      dispatch({
        type: 'POST_WARRANTY_INFO_RESET',
      });
    }
  }, [dispatch, postWarrantyRequestId, infoPosted, queryClient]);

  const isNotWarranty = request.garantyId === notWarrantyId;

  return (
    <Card
      {...props}
      className={cn(styles.root, className)}
    >
      <Spin
        wrapperClassName={styles.spin}
        spinning={isWarrantyInfoFetching}
      >
        {!isNotWarranty && (
          <>
            <CardHeader
              title="Подрядчик"
              className={styles.header}
              action={
                warrantyInfo && CanChangeWarranty && canChange ? (
                  <CardChangeButton
                    className={styles.changeButton}
                    onClick={handleAddContractorBtnClick}
                  />
                ) : undefined
              }
            />
            <WarrantyInfoBlock
              warrantyInfo={warrantyInfo}
              onEmptyBlockClick={
                CanChangeWarranty && canChange
                  ? handleAddContractorBtnClick
                  : undefined
              }
            />
          </>
        )}

        <WarrantyDocs
          request={request}
          warrantyInfo={warrantyInfo}
          canChangeWarranty={CanChangeWarranty && canChange && !isNotWarranty}
        />
      </Spin>
    </Card>
  );
};

export default RequestContractorCard;
